module.exports = __webpack_public_path__ + "img/Group 97802.f3a74522.png";